module.exports = __webpack_public_path__ + "static/hp2-service-5-2bf830f789d2cff6649ace5275608116.jpg";